import styled from 'styled-components';
import { sizes } from 'style';
import { motion } from 'framer-motion6';

export const DoWellBackground = styled.div`
  width: 100%;
  min-height: 630px;
  background-color: ${({ theme }) => theme.colors.black};
`;

export const DoWellContainer = styled.div`
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  max-width: 1340px;
  margin: 0px auto;

  > h1 {
    font-weight: 700;
    font-size: 24px;
    line-height: 40px;
    margin-bottom: 38px;

    @media ${sizes.tabletLandscape} {
      margin-bottom: 62px;
      font-size: 32px;
      line-height: 40px;
    }
  }

  @media ${sizes.tabletLandscape} {
    padding-left: 40px;
    padding-right: 40px;
  }
`;

export const GridContainer = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 40px;
  grid-auto-rows: 1fr;

  @media ${sizes.mobileLarge} {
    grid-template-columns: repeat(1, 327px);
    grid-gap: 55px 118px;
  }

  @media ${sizes.desktop} {
    grid-template-columns: repeat(2, 327px);
  }

  @media ${sizes.extraLargeDesktop} {
    grid-template-columns: repeat(3, 327px);
  }
`;

export const SeeOpenRoles = styled(motion.button)`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: 0;
  color: ${({ theme }) => theme.colors.black};
  background-color: ${({ theme }) => theme.colors.turquoise};
  font-size: 16px;
  line-height: 26px;
  font-weight: 600;
  border-radius: 12px;
  padding: 10px 36px;
  transition: background-color 0.3s;
  margin-top: 65px;

  :hover {
    background-color: ${({ theme }) => theme.colors.cyan};
  }

  @media ${sizes.tabletLandscape} {
    margin-top: 80px;
  }
`;
